import React, { Component } from 'react';
import { apiGet } from '../../Api';
import AdminAPI from './AdminAPI';
import { ImageLoader } from '../Game/ImageLoader';
import { MEDIA_VARIANTS } from '../../media';
import { buildItemImagePrompt } from './itemImagePrompt';
import { salvageLearningDisabledReason } from './recipeLearning';
import {
    buildConsumableEffectTargets,
    createConsumableEffect,
    findConsumableEffectTarget,
    formatConsumableDuration,
    formatConsumableEffect,
    getConsumableDurationSeconds,
    getConsumableEffects,
    getConsumableTargetValue,
    isTimedConsumableEffect,
    normalizeConsumableItemForSubmit,
    RESTORE_HEALTH_FLAT,
    RESTORE_SATIETY_FLAT,
    TEMPORARY_ATTRIBUTE_FLAT,
    TEMPORARY_STAT_FLAT,
    validateConsumableEffects,
} from '../Game/consumableEffects';

export default class ItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            item: null,
            selectedItemPopup: null, //temp
            loadedItems: {},
            itemFor: "",//Craft or Trophy
            copyMessage: "",
            consumableDurationUnit: 'minutes',
            consumableValidationAttempted: false,
            recipeLearningBusy: false,
            recipeLearningError: '',
            recipeLearningMessage: '',
        };
        this.consumableValidationSummaryRef = React.createRef();
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.itemId !== prevProps.itemId || this.props.creatingNewItem !== prevProps.creatingNewItem) {
            console.log("get item");
            this.setState({
                imageFile: null,
                imagePreviewUrl: null,
                recipeLearningError: '',
                recipeLearningMessage: '',
                recipeLearningBusy: false,
            });
            this.getThisItem();
        }


        if (this.props.selectedItemPopup && this.props.selectedItemPopup !== this.state.selectedItemPopup) {

            let item = this.state.item;
            if (this.state.itemFor === "Craft") {
                if (item) {

                    if (!item.craftingMats) {

                        item.craftingMats = [];
                    }
                    else {


                        const fetchedItems = this.state.loadedItems;
                        item.craftingMats.map(async (obj) => {
                            const item = await this.getItem(obj.itemId);
                            fetchedItems[obj.itemId] = item;
                        });
                        this.setState({ loadedItems: fetchedItems });

                    }
                    item.craftingMats.push({ itemId: this.props.selectedItemPopup.id })
                    this.setState({ selectedItemPopup: this.props.selectedItemPopup });

                }
            }
            else if (this.state.itemFor === "Trophy") {
                if (item) {

                    if (!item.trophieItemIds) {

                        item.trophieItemIds = [];
                    }
                    else {


                        const fetchedItems = this.state.loadedItems;
                        item.trophieItemIds.map(async (itemId) => {
                            const item = await this.getItem(itemId);
                            fetchedItems[itemId] = item;
                        });
                        this.setState({ loadedItems: fetchedItems });

                    }
                    item.trophieItemIds.push(this.props.selectedItemPopup.id)
                    this.setState({ selectedItemPopup: this.props.selectedItemPopup });

                }
            }
        }
    }
    handleImageLoad = async (itemId) => {

        var item = this.state.loadedItems[itemId];
        if (!item) {

            const fetchedItems = this.state.loadedItems;
            item = await this.getItem(itemId);

            fetchedItems[itemId] = item;

            this.setState({ loadedItems: fetchedItems });

        }
    }

    getThisItem = async () => {
        if (this.props.itemId != null) {
            if (this.props.itemId === "") {
                this.setState({
                    item: {
                        name: "",
                        flavourText: "",
                        visualDescription: "",
                        imageId: "",
                        mapImageId: "",
                        stats: null,
                        price: null,
                        craftedItemLevel: null,
                        visible: true,
                        dropsFromEnemies: true,
                        scavengeDurationSeconds: 30,
                        consumableDurationSeconds: null,
                        consumableEffects: [],
                        isCraftable: false,
                        recipeUnlockMode: 'automatic',
                        salvagesRequiredToLearn: 0,
                    },
                    imageFile: null,
                    imagePreviewUrl: "",
                    consumableDurationUnit: 'minutes',
                    consumableValidationAttempted: false,
                    recipeLearningBusy: false,
                    recipeLearningError: '',
                    recipeLearningMessage: '',
                });
            }
            else {
                const response = await apiGet("/item/" + this.props.itemId);
                if (response.ok) {
                    const itm = await response.json();
                    const durationSeconds = Number(getConsumableDurationSeconds(itm));
                    this.setState({
                        item: itm,
                        consumableDurationUnit: (
                            Number.isFinite(durationSeconds)
                            && durationSeconds >= 3600
                            && durationSeconds % 3600 === 0
                        ) ? 'hours' : 'minutes',
                        consumableValidationAttempted: false,
                        recipeLearningBusy: false,
                        recipeLearningError: '',
                        recipeLearningMessage: '',
                    });
                    if (itm.imageId) {

                        this.setState({ imagePreviewUrl: await AdminAPI.fetchImage(itm.imageId) });
                    }

                }
            }
        }
        else {
            this.setState({ item: null });
        }
    }

    getItem = async (itemId) => {


        const response = await apiGet("/item/" + itemId);
        if (response.ok) {
            const itm = await response.json();
            console.log(itm);
            return itm;
        }
        return null;

    }

    handleImageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
            this.handleUpload(file);

        };

        reader.readAsDataURL(file);


    };




    handleUpload = async (file) => {
        const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.entity.v1');
        if (assetId) {
            const item = { ...this.state.item, imageId: assetId };
            this.setState({ item });
        }
    };

    handleAnimatedMediaChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.entityVideo.v1');
        if (assetId) {
            this.setState((prev) => ({
                item: { ...prev.item, animatedMediaId: assetId },
            }));
        }
    };

    handleMapImageChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.entity.v1');
        if (assetId) {
            this.setState((prev) => ({
                item: {
                    ...prev.item,
                    mapImageId: assetId,
                    scavengeDurationSeconds:
                        Number(prev.item.scavengeDurationSeconds) >= 1
                            ? prev.item.scavengeDurationSeconds
                            : 30,
                },
            }));
        }
    };

    copyPrompt = async (prompt, label) => {
        try {
            await navigator.clipboard.writeText(prompt);
            this.setState({ copyMessage: `${label} prompt copied.` });
        } catch (error) {
            console.error('Failed to copy item image prompt', error);
            this.setState({ copyMessage: 'Copy failed. Select the prompt and copy it manually.' });
        }
    };






    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (name === "craftedItemLevel") {
            if (event.target.value === "") {
                value = null;
            } else {
                const parsed = Number.parseInt(event.target.value, 10);
                value = Number.isFinite(parsed) ? parsed : null;
            }
        } else if (name === "salvagesRequiredToLearn") {
            value = event.target.value === ''
                ? ''
                : Number.parseInt(event.target.value, 10);
        } else if (name === "scavengeDurationSeconds") {
            const parsed = Number.parseInt(event.target.value, 10);
            value = Number.isFinite(parsed) && parsed >= 1
                ? parsed
                : 30;
        } else if (name === "needSub") {
            value = parseInt(event.target.value, 10);
        }
        else {
            value = event.target.value;
        }
        const item = { ...this.state.item, [name]: value };
        this.setState({ item });
    };

    setSalvageRecipeLearning = (event) => {
        const enabled = event.target.checked;
        this.setState((current) => ({
            item: {
                ...current.item,
                recipeUnlockMode: enabled ? 'salvage' : 'automatic',
                salvagesRequiredToLearn: enabled
                    ? Math.max(
                        1,
                        Number(current.item.salvagesRequiredToLearn) || 10,
                    )
                    : 0,
                recipeItemId: '',
            },
            recipeLearningError: '',
            recipeLearningMessage: '',
        }));
    };

    saveRecipeLearning = async () => {
        const { item } = this.state;
        if (!this.props.onUpdateRecipeLearning || !item?.id) return;
        this.setState({
            recipeLearningBusy: true,
            recipeLearningError: '',
            recipeLearningMessage: '',
        });
        try {
            const saved = await this.props.onUpdateRecipeLearning(item);
            this.setState((current) => ({
                item: saved ? {
                    ...current.item,
                    recipeUnlockMode: saved.recipeUnlockMode
                        ?? saved.RecipeUnlockMode
                        ?? current.item.recipeUnlockMode,
                    recipeItemId: saved.recipeItemId
                        ?? saved.RecipeItemId
                        ?? current.item.recipeItemId,
                    salvagesRequiredToLearn: saved.salvagesRequiredToLearn
                        ?? saved.SalvagesRequiredToLearn
                        ?? current.item.salvagesRequiredToLearn,
                } : current.item,
                recipeLearningBusy: false,
                recipeLearningMessage: 'Recipe learning settings saved.',
            }));
        } catch (error) {
            this.setState({
                recipeLearningBusy: false,
                recipeLearningError: `${error?.message
                    || 'Recipe learning settings could not be saved.'} Your input has been preserved.`,
            });
        }
    };

    getConsumableEffectTargets = () => buildConsumableEffectTargets(
        this.props.consumableEffectTargets,
        this.props.stats,
    );

    addConsumableEffect = () => {
        const effects = getConsumableEffects(this.state.item);
        const usedTargets = new Set(effects.map(getConsumableTargetValue));
        const target = this.getConsumableEffectTargets()
            .find(candidate => !usedTargets.has(candidate.value));
        if (!target) {
            return;
        }
        const nextEffects = [...effects, createConsumableEffect(target)];
        const currentDuration = Number(getConsumableDurationSeconds(this.state.item));
        const needsDefaultDuration = isTimedConsumableEffect(nextEffects[nextEffects.length - 1])
            && (!Number.isFinite(currentDuration) || currentDuration <= 0);
        this.setState({
            item: {
                ...this.state.item,
                consumableEffects: nextEffects,
                ...(needsDefaultDuration ? { consumableDurationSeconds: 300 } : {}),
            },
        });
    };

    handleConsumableEffectTargetChange = (index, event) => {
        const target = this.getConsumableEffectTargets()
            .find(candidate => candidate.value === event.target.value);
        if (!target) {
            return;
        }
        const effects = [...getConsumableEffects(this.state.item)];
        const amount = effects[index]?.amount ?? effects[index]?.Amount ?? 1;
        effects[index] = createConsumableEffect(target, amount);
        const hasTimedEffects = effects.some(isTimedConsumableEffect);
        const duration = Number(getConsumableDurationSeconds(this.state.item));
        this.setState({
            item: {
                ...this.state.item,
                consumableEffects: effects,
                consumableDurationSeconds: hasTimedEffects
                    ? (duration > 0 ? duration : 300)
                    : null,
            },
        });
    };

    handleConsumableEffectAmountChange = (index, event) => {
        const parsed = event.target.value === ''
            ? ''
            : Number.parseFloat(event.target.value);
        const effects = [...getConsumableEffects(this.state.item)];
        effects[index] = {
            ...effects[index],
            type: effects[index]?.type
                ?? effects[index]?.Type
                ?? RESTORE_HEALTH_FLAT,
            amount: parsed === '' || Number.isFinite(parsed) ? parsed : '',
        };
        this.setState({
            item: {
                ...this.state.item,
                consumableEffects: effects,
            },
        });
    };

    handleConsumableDurationAmountChange = (event) => {
        const amount = Number.parseFloat(event.target.value);
        const multiplier = this.state.consumableDurationUnit === 'hours'
            ? 3600
            : 60;
        this.setState({
            item: {
                ...this.state.item,
                consumableDurationSeconds: Number.isFinite(amount)
                    ? Math.round(amount * multiplier)
                    : null,
            },
        });
    };

    handleConsumableDurationUnitChange = (event) => {
        const previousMultiplier = this.state.consumableDurationUnit === 'hours'
            ? 3600
            : 60;
        const nextUnit = event.target.value;
        const nextMultiplier = nextUnit === 'hours' ? 3600 : 60;
        const currentAmount = Number(getConsumableDurationSeconds(this.state.item))
            / previousMultiplier;
        this.setState({
            consumableDurationUnit: nextUnit,
            item: {
                ...this.state.item,
                consumableDurationSeconds: Number.isFinite(currentAmount)
                    ? Math.round(currentAmount * nextMultiplier)
                    : null,
            },
        });
    };

    removeConsumableEffect = (index) => {
        const effects = [...getConsumableEffects(this.state.item)];
        effects.splice(index, 1);
        this.setState({
            item: {
                ...this.state.item,
                consumableEffects: effects,
                consumableDurationSeconds: effects.some(isTimedConsumableEffect)
                    ? getConsumableDurationSeconds(this.state.item)
                    : null,
            },
        });
    };

    getConsumableValidationErrors = () => {
        const errors = validateConsumableEffects(
            this.state.item,
            this.getConsumableEffectTargets(),
        );
        const selectedItemType = this.props.itemTypes.find(
            candidate => candidate.id === this.state.item.typeId,
        );
        const isConsumable = Boolean(
            selectedItemType?.isConsumable
            ?? selectedItemType?.IsConsumable,
        );
        const effects = getConsumableEffects(this.state.item);
        if (isConsumable && effects.length === 0) {
            errors.unshift({
                field: 'effects',
                message: 'Consumable items need at least one effect.',
            });
        } else if (effects.length > 0 && !isConsumable) {
            errors.unshift({
                field: 'item-type',
                message: 'Select an item type marked as consumable before saving effects.',
            });
        }
        return errors;
    };

    submitItem = (callback) => {
        const errors = this.getConsumableValidationErrors();
        if (errors.length > 0) {
            this.setState(
                { consumableValidationAttempted: true },
                () => this.consumableValidationSummaryRef.current?.focus(),
            );
            return;
        }
        callback(normalizeConsumableItemForSubmit(this.state.item));
    };

    addAnotherStat = (event) => {

        let statId = event.target.value;
        if (!statId || statId === "default") {
            return;
        }
        let stat = this.props.stats.find(x => x.id === statId);
        if (!stat) {
            return;
        }
        let se = { statId: stat.id, valueFrom: 0, valueTo: 0, statType: stat.statType };
        const currentEntries = this.state.item.stats?.statEntries ?? [];
        if (currentEntries.some(entry => entry.statId === stat.id)) {
            return;
        }
        this.setState({
            item: {
                ...this.state.item,
                stats: {
                    ...(this.state.item.stats || {}),
                    statEntries: [...currentEntries, se],
                },
            },
        });
    }

    removeStat = (statId) => {
        const currentEntries = this.state.item.stats?.statEntries ?? [];
        this.setState({
            item: {
                ...this.state.item,
                stats: {
                    ...(this.state.item.stats || {}),
                    statEntries: currentEntries.filter(entry => entry.statId !== statId),
                },
            },
        });
    }

    handleStatsChange = (event, stat) => {
        const name = event.target.name;
        const nameValues = name.split("_$$_");
        // console.log(nameValues);
        const parsedValue = Number.parseFloat(event.target.value);
        const value = Number.isFinite(parsedValue) ? parsedValue : 0;



        let item = this.state.item;
        if (item.stats === null) {
            item.stats = { statEntries: [] };
            let se = { statId: stat.id, valueFrom: 0, valueTo: 0, statType: stat.statType }
            se = { name: nameValues[0], [nameValues[1]]: value };
            item.stats.statEntries.push(se);
        }
        else {

            let se = item.stats.statEntries?.find(entry => entry.statId === nameValues[0]);

            if (se)
                se[nameValues[1]] = value;
            else {
                se = { name: nameValues[0], [nameValues[1]]: value };
                item.stats.statEntries.push(se);
            }

        }
        this.setState({ item });
    };

    handlePriceChange = (event) => {
        const name = event.target.name;
        let value = parseInt(event.target.value);



        let item = this.state.item;
        if (item.price === null) {
            item.price = { currencyEntries: [] };
            let se = { name: name, value: value };
            item.price.currencyEntries.push(se);
        }
        else {
            let se = item.price.currencyEntries.find(entry => entry.name === name);
            if (se)
                se.value = value;
            else {
                se = { name: name, value: value };
                item.price.currencyEntries.push(se);
            }

        }
        this.setState({ item });
    };

    handleRefundChange = (event) => {
        const name = event.target.name;
        let value = parseInt(event.target.value);



        let item = this.state.item;
        if (item.refund === null || !item.refund) {
            item.refund = { currencyEntries: [] };
            let se = { name: name, value: value };
            item.refund.currencyEntries.push(se);
        }
        else {
            let se = item.refund.currencyEntries.find(entry => entry.name === name);
            if (se)
                se.value = value;
            else {
                se = { name: name, value: value };
                item.refund.currencyEntries.push(se);
            }

        }
        this.setState({ item });
    };

    handleInputChangeCraftingMats = (event, item_in, index) => {
        const name = event.target.name;
        let value = parseInt(event.target.value);

        let item = this.state.item;
        const craftitem = { ...item.craftingMats[index], [name]: value };
        item.craftingMats[index] = craftitem;
        this.setState({ item });

    }

    removeCraftingItem = (event) => {
        event.stopPropagation();
        let item = { ...this.state.item };  // Make a shallow copy
        const targetValue = event.target.value.trim();
        console.log("Target value:", targetValue);

        item.craftingMats = item.craftingMats.filter(x => {
            // console.log("Comparing item:", x.itemId.trim(), "with", targetValue);
            // console.log(x.itemId.trim() !== targetValue);
            if (x.itemId)
                return x.itemId.trim() !== targetValue;
            else
                return false;

        });

        this.setState({ item });
    }

    removeTrophyItem = (event) => {
        event.stopPropagation();
        let item = { ...this.state.item };  // Make a shallow copy
        const targetValue = event.target.value.trim();
        console.log("Target value:", targetValue);

        item.trophieItemIds = item.trophieItemIds.filter(itemId => {

            if (itemId)
                return itemId.trim() !== targetValue;
            else
                return false;

        });

        this.setState({ item });
    }

    showItemPopup = (event) => {

        this.setState({ itemFor: event.target.id });

        this.props.showItemPopup();
    }

    render() {
        const { onUpdate, onDelete, onCreate, creatingNewItem, onCancelCreate, itemTypes, stats, currencies, rarity, enemyTypes, showItemPopup, regions, enemies } = this.props;
        const { item, imagePreviewUrl, loadedItems } = this.state;

        if (!item || item == null) return <div>Select a item to see details</div>;
        const selectedItemType = itemTypes.find(candidate => candidate.id === item.typeId);
        const isConsumable = Boolean(
            selectedItemType?.isConsumable
            ?? selectedItemType?.IsConsumable,
        );
        const consumableEffects = item.consumableEffects
            ?? item.ConsumableEffects
            ?? [];
        const consumableTargets = this.getConsumableEffectTargets();
        const timedConsumableEffects = consumableEffects.filter(isTimedConsumableEffect);
        const instantConsumableEffects = consumableEffects.filter(
            effect => !isTimedConsumableEffect(effect),
        );
        const durationMultiplier = this.state.consumableDurationUnit === 'hours'
            ? 3600
            : 60;
        const durationSeconds = getConsumableDurationSeconds(item);
        const durationAmount = durationSeconds === null || durationSeconds === undefined
            ? ''
            : Number(durationSeconds) / durationMultiplier;
        const consumableValidationErrors = this.getConsumableValidationErrors();
        const showConsumableValidation = this.state.consumableValidationAttempted;
        const unusedConsumableTargetExists = consumableTargets.some(target => (
            !consumableEffects.some(effect => getConsumableTargetValue(effect) === target.value)
        ));
        const itemTypeName = selectedItemType?.name ?? selectedItemType?.Name ?? '';
        const itemImagePrompt = buildItemImagePrompt(item, itemTypeName);
        const mapImagePrompt = buildItemImagePrompt(
            item,
            itemTypeName,
            { mapRepresentation: true },
        );
        const recipeUnlockMode = String(
            item.recipeUnlockMode ?? item.RecipeUnlockMode ?? 'automatic',
        ).toLowerCase();
        const salvageLearningEnabled = recipeUnlockMode === 'salvage';
        const salvageDisabledReason = salvageLearningDisabledReason(
            item,
            itemTypes,
            this.props.starterItemIds,
        );
        const hasRecipeAssignment = Boolean(
            (item.isCraftable ?? item.IsCraftable)
            && String(item.professionKey ?? item.ProfessionKey ?? '').trim(),
        );
        const salvageCount = salvageLearningEnabled
            ? item.salvagesRequiredToLearn
                ?? item.SalvagesRequiredToLearn
                ?? 10
            : 0;
        const invalidSalvageCount = salvageLearningEnabled
            && (!Number.isInteger(Number(salvageCount))
                || Number(salvageCount) < 1);
        const materialUses = (this.props.items || [])
            .map((candidate) => {
                const materials = candidate.craftingMats
                    ?? candidate.CraftingMats
                    ?? [];
                const matches = materials.filter(material => String(
                    material.itemId ?? material.ItemId ?? '',
                ) === String(item.id ?? item.Id ?? ''));
                if (matches.length === 0) return null;
                return {
                    id: candidate.id ?? candidate.Id,
                    name: candidate.name ?? candidate.Name,
                    amount: matches.reduce((total, material) => (
                        total + Number(material.amount ?? material.Amount ?? 0)
                    ), 0),
                };
            })
            .filter(Boolean)
            .sort((left, right) => (
                String(left.name || left.id).localeCompare(String(right.name || right.id))
                || String(left.id).localeCompare(String(right.id))
            ));

        return (
            <div className='admin_details'>
                <label>Name:
                    <input id="name" type="text" name="name" value={item.name} onChange={this.handleInputChange} />
                </label>
                {/* <label>Short Name:
                    <input type="text" value={item.name} onChange={e => this.setState({ item: { ...item, name: e.target.value } })} />
                </label> */}
                <label className='labelBackground1'>
                    ItemType:
                    <select
                        key="itemitemtype"
                        name="typeId"
                        value={item.typeId || ''}
                        onChange={this.handleInputChange}
                    >
                        <option key="" value=""></option>
                        <option key={"nonetype"} value=""></option>
                        {itemTypes.map((obj, index) =>
                            <option key={index} value={obj.id}>{obj.name}</option>
                        )}

                    </select>
                </label>
                {/* {itemTypes.find((x) => x.name === "retainer").id === item.type ?
                    <label className='labelBackground1'>
                        Retainer specific Settings:
                        <label className='labelBackground2'>
                            CreatureType:
                            <select
                                name="creatureType"
                                value={item.creatureType}
                                onChange={this.handleInputChange}
                            >
                                <option key="" value=""></option>
                                {enemyTypes.map((obj, index) =>
                                    <option key={index} value={obj.id}>{obj.name}</option>
                                )}

                            </select>
                        </label>
                    </label>
                    : ""
                }
                {itemTypes.find((x) => x.name === "collection").id === item.type ?
                    <label className='labelBackground1'>
                        Collection specific Settings:
                        <label className='labelBackground2'>
                            Trophies in this Collection:

                            <div className='row'>
                                {item.trophieItemIds?.map((itemId, index) => {
                                    const item = loadedItems[itemId];
                                    if (!item) this.handleImageLoad(itemId);
                                    return (
                                        <div key={itemId} className='gridItem'>
                                            <div className='image-wrapper'>
                                                {loadedImages[item?.imageId] ? (
                                                    <img
                                                        src={loadedImages[item?.imageId]}
                                                        alt={item?.name}
                                                        loading="lazy"
                                                    />
                                                ) : (
                                                    <img

                                                        alt="placeholder"

                                                        loading="lazy"
                                                    />
                                                )}
                                                <button className='floatingDelTopRight' value={itemId} onMouseUp={this.removeTrophyItem}>X</button>
                                                <p>{item?.name}</p>
                                            </div>


                                        </div>
                                    );

                                })}
                            </div>
                            <div><label>Add another trophy:</label>
                                <button id="Trophy" onClick={this.showItemPopup}>Add</button>
                            </div>
                        </label>


                    </label>
                    : ""
                } */}
                <label className='labelBackground2'>
                    Fixed loot rarity:
                    <select
                        aria-describedby="item-fixed-loot-rarity-help"
                        id="itemrarity"
                        name="rarityId"
                        value={item.rarityId || ''}
                        onChange={this.handleInputChange}
                    >
                        <option
                            disabled={Boolean(
                                selectedItemType?.isStackable
                                ?? selectedItemType?.IsStackable
                            )}
                            key={"nonerarity"}
                            value=""
                        >
                            Dynamically rolled
                        </option>
                        {rarity.map((obj, index) =>
                            <option key={index} value={obj.id}>{obj.name}</option>
                        )}

                    </select>
                    <small id="item-fixed-loot-rarity-help">
                        Dynamically rolled equipment uses the normal loot formula.
                        Choosing a rarity guarantees it. Stackable items require a fixed rarity.
                    </small>
                </label>
                <label>Crafted Item Level:
                    <input
                        type="number"
                        min="1"
                        step="1"
                        name="craftedItemLevel"
                        value={item.craftedItemLevel ?? ""}
                        onChange={this.handleInputChange}
                    />
                    <small>Used for crafted equipment; leave blank to use the default item level.</small>
                </label>

                <fieldset className="admin-progression-fieldset admin-recipe-learning">
                    <legend>Recipe Learning</legend>
                    <p className="admin-recipe-learning__status">
                        <strong>Reverse engineerable:</strong>{' '}
                        {salvageLearningEnabled && salvageDisabledReason
                            ? `No — ${salvageDisabledReason} The existing setting must be disabled.`
                            : salvageLearningEnabled
                            ? `Yes — ${salvageCount} salvaged copies required.`
                            : salvageDisabledReason
                                ? `No — ${salvageDisabledReason}`
                                : 'Eligible, but not enabled.'}
                    </p>
                    <label>
                        <input
                            aria-describedby="item-recipe-learning-help"
                            checked={salvageLearningEnabled}
                            disabled={!hasRecipeAssignment
                                || (Boolean(salvageDisabledReason)
                                    && !salvageLearningEnabled)}
                            onChange={this.setSalvageRecipeLearning}
                            type="checkbox"
                        />
                        Enable reverse engineering for this recipe
                    </label>
                    <label>
                        Salvages per item level:
                        <input
                            aria-describedby={invalidSalvageCount
                                ? 'item-recipe-learning-help item-recipe-learning-count-error'
                                : 'item-recipe-learning-help'}
                            aria-invalid={invalidSalvageCount}
                            disabled={!hasRecipeAssignment
                                || !salvageLearningEnabled}
                            min="1"
                            name="salvagesRequiredToLearn"
                            onChange={this.handleInputChange}
                            required={salvageLearningEnabled}
                            step="1"
                            type="number"
                            value={salvageCount}
                        />
                        {invalidSalvageCount ? (
                            <small
                                className="admin-consumable-error"
                                id="item-recipe-learning-count-error"
                            >
                                Enter a whole number of at least 1.
                            </small>
                        ) : null}
                    </label>
                    <small id="item-recipe-learning-help">
                        {hasRecipeAssignment
                            ? 'Any legitimate Pack or Vault copy counts. Each configured interval teaches the next item level; disabling makes the recipe automatic.'
                            : 'Assign this item to a profession before enabling reverse engineering.'}
                    </small>
                    {this.state.recipeLearningError ? (
                        <p className="admin-consumable-error" role="alert">
                            {this.state.recipeLearningError}
                        </p>
                    ) : null}
                    <p aria-live="polite" role="status">
                        {this.state.recipeLearningMessage}
                    </p>
                    <div className="admin-recipe-learning__actions">
                        <button
                            className="button-primary"
                            disabled={!hasRecipeAssignment
                                || this.state.recipeLearningBusy
                                || invalidSalvageCount
                                || (salvageLearningEnabled
                                    && Boolean(salvageDisabledReason))}
                            onClick={this.saveRecipeLearning}
                            type="button"
                        >
                            {this.state.recipeLearningBusy
                                ? 'Saving…'
                                : 'Save recipe learning'}
                        </button>
                        <a href="/admin/professions">
                            {hasRecipeAssignment
                                ? 'Open full recipe assignment'
                                : 'Assign item to a profession'}
                        </a>
                    </div>
                </fieldset>

                <label>Image:
                    <input id="itemimage" type="file" onChange={this.handleImageChange} />
                    {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" className='adminPreviewImage' />}
                </label>
                <label>Map icon image:
                    <input
                        id="itemmapimage"
                        type="file"
                        accept="image/png"
                        onChange={this.handleMapImageChange}
                    />
                    <small>Optional top-down resource or crafting-material artwork.</small>
                    {item.mapImageId && (
                        <ImageLoader
                            className="adminPreviewImage"
                            imageId={item.mapImageId}
                            variant={MEDIA_VARIANTS.ENTITY_ICON}
                            alt="Map icon preview"
                        />
                    )}
                </label>
                <label>Scavenge time (seconds):
                    <input
                        type="number"
                        min="1"
                        step="1"
                        name="scavengeDurationSeconds"
                        value={item.scavengeDurationSeconds ?? 30}
                        onChange={this.handleInputChange}
                    />
                    <small>Global for this item in every map and region; defaults to 30 seconds.</small>
                </label>
                <label>Animated media:
                    <input type="file" accept="video/*" onChange={this.handleAnimatedMediaChange} />
                </label>
                {(item.animatedMediaId || item.animatedImageId) && (
                    <ImageLoader
                        className="adminPreviewImage"
                        imageId={item.imageId}
                        animatedMediaId={item.animatedMediaId || item.animatedImageId}
                        variant={MEDIA_VARIANTS.PICTURE}
                        alt="Item media preview"
                    />
                )}

                <label>Flavor Text:
                    <textarea id="itemflavourtext" name="flavourText" value={item.flavourText} onChange={this.handleInputChange} ></textarea>
                </label>

                <label>Visual Description:
                    <textarea type="text" name="visualDescription" value={item.visualDescription} onChange={this.handleInputChange} />
                </label>

                <details className="admin-progression-fieldset admin-image-prompt">
                    <summary>Image Generator Prompts</summary>
                    <label>Item artwork:
                        <textarea aria-label="Item Artwork Image Generator Prompt" readOnly rows="8" value={itemImagePrompt} />
                    </label>
                    <button type="button" onClick={() => this.copyPrompt(itemImagePrompt, 'Item artwork')}>
                        Copy Item Prompt
                    </button>
                    <label>Optional map resource representation:
                        <textarea aria-label="Item Map Representation Image Generator Prompt" readOnly rows="8" value={mapImagePrompt} />
                    </label>
                    <button type="button" onClick={() => this.copyPrompt(mapImagePrompt, 'Map representation')}>
                        Copy Map Prompt
                    </button>
                    {this.state.copyMessage && <span role="status">{this.state.copyMessage}</span>}
                </details>

                <label>Visible:
                    <input type="checkbox" name="visible" checked={item.visible} onChange={this.handleInputChange} />
                </label>

                {(isConsumable || consumableEffects.length > 0) && (
                    <fieldset className="admin-progression-fieldset">
                        <legend>Consumable Effects</legend>
                        {!isConsumable && (
                            <p role="alert">
                                This item has effects, but its selected item type is not marked consumable.
                            </p>
                        )}
                        {showConsumableValidation && consumableValidationErrors.length > 0 && (
                            <div
                                className="admin-consumable-validation"
                                ref={this.consumableValidationSummaryRef}
                                role="alert"
                                tabIndex="-1"
                            >
                                <strong>Consumable effects could not be saved:</strong>
                                <ul>
                                    {consumableValidationErrors.map((error, index) => (
                                        <li key={`${error.field}-${index}`}>{error.message}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {consumableEffects.map((effect, index) => {
                            const selectedTargetValue = getConsumableTargetValue(effect);
                            const selectedTarget = findConsumableEffectTarget(
                                effect,
                                consumableTargets,
                            );
                            const usedByAnotherEffect = new Set(
                                consumableEffects
                                    .filter((_candidate, candidateIndex) => candidateIndex !== index)
                                    .map(getConsumableTargetValue),
                            );
                            const targetError = showConsumableValidation
                                ? consumableValidationErrors.find(
                                    error => error.field === `target-${index}`,
                                )
                                : null;
                            const amountError = showConsumableValidation
                                ? consumableValidationErrors.find(
                                    error => error.field === `amount-${index}`,
                                )
                                : null;
                            const targetErrorId = `consumable-effect-${index}-target-error`;
                            const amountErrorId = `consumable-effect-${index}-amount-error`;
                            return (
                                <div className="admin-progression-effect" key={`${selectedTargetValue}-${index}`}>
                                    <label>Target:
                                        <select
                                            aria-describedby={targetError ? targetErrorId : undefined}
                                            aria-invalid={Boolean(targetError)}
                                            aria-label={`Consumable effect ${index + 1} target`}
                                            onChange={(event) => this.handleConsumableEffectTargetChange(index, event)}
                                            value={selectedTargetValue}
                                        >
                                        {!selectedTarget && (
                                            <option value={selectedTargetValue}>
                                                Unsupported effect target
                                            </option>
                                        )}
                                        <optgroup label="Instant">
                                            {consumableTargets
                                                .filter(target => (
                                                    target.effectType === RESTORE_HEALTH_FLAT
                                                    || target.effectType === RESTORE_SATIETY_FLAT
                                                ))
                                                .map(target => (
                                                    <option
                                                        disabled={usedByAnotherEffect.has(target.value)}
                                                        key={target.value}
                                                        value={target.value}
                                                    >
                                                        {target.displayName}
                                                    </option>
                                                ))}
                                        </optgroup>
                                        <optgroup label="Stats">
                                            {consumableTargets
                                                .filter(target => target.effectType === TEMPORARY_STAT_FLAT)
                                                .map(target => (
                                                    <option
                                                        disabled={usedByAnotherEffect.has(target.value)}
                                                        key={target.value}
                                                        value={target.value}
                                                    >
                                                        {target.displayName}
                                                    </option>
                                                ))}
                                        </optgroup>
                                        <optgroup label="Attributes">
                                            {consumableTargets
                                                .filter(target => target.effectType === TEMPORARY_ATTRIBUTE_FLAT)
                                                .map(target => (
                                                    <option
                                                        disabled={usedByAnotherEffect.has(target.value)}
                                                        key={target.value}
                                                        value={target.value}
                                                    >
                                                        {target.displayName}
                                                    </option>
                                                ))}
                                        </optgroup>
                                        </select>
                                        {targetError && (
                                            <small className="admin-consumable-error" id={targetErrorId}>
                                                {targetError.message}
                                            </small>
                                        )}
                                    </label>
                                    <label>Amount:
                                        <input
                                            aria-describedby={amountError ? amountErrorId : undefined}
                                            aria-invalid={Boolean(amountError)}
                                            aria-label={`Consumable effect ${index + 1} amount`}
                                            type="number"
                                            min="0.01"
                                            step={selectedTarget?.inputStep || 0.01}
                                            value={effect.amount ?? effect.Amount ?? 0}
                                            onChange={(event) => this.handleConsumableEffectAmountChange(index, event)}
                                        />
                                        {selectedTarget?.unit && (
                                            <small>Player-facing unit: {selectedTarget.unit.trim()}</small>
                                        )}
                                        {amountError && (
                                            <small className="admin-consumable-error" id={amountErrorId}>
                                                {amountError.message}
                                            </small>
                                        )}
                                    </label>
                                    <button
                                        aria-label={`Remove consumable effect ${index + 1}`}
                                        type="button"
                                        onClick={() => this.removeConsumableEffect(index)}
                                    >
                                        Remove effect
                                    </button>
                                </div>
                            );
                        })}
                        {timedConsumableEffects.length > 0 && (
                            <div className="admin-consumable-duration">
                                <label>Temporary effect duration:
                                    <input
                                        aria-describedby={
                                            showConsumableValidation
                                            && consumableValidationErrors.some(error => error.field === 'duration')
                                                ? 'consumable-duration-error'
                                                : undefined
                                        }
                                        aria-invalid={
                                            showConsumableValidation
                                            && consumableValidationErrors.some(error => error.field === 'duration')
                                        }
                                        min="1"
                                        onChange={this.handleConsumableDurationAmountChange}
                                        step="1"
                                        type="number"
                                        value={durationAmount}
                                    />
                                </label>
                                <label>Duration unit:
                                    <select
                                        onChange={this.handleConsumableDurationUnitChange}
                                        value={this.state.consumableDurationUnit}
                                    >
                                        <option value="minutes">Minutes</option>
                                        <option value="hours">Hours</option>
                                    </select>
                                </label>
                                {showConsumableValidation
                                    && consumableValidationErrors
                                        .filter(error => error.field === 'duration')
                                        .map((error, index) => (
                                            <small
                                                className="admin-consumable-error"
                                                id="consumable-duration-error"
                                                key={`${error.field}-${index}`}
                                            >
                                                {error.message}
                                            </small>
                                        ))}
                            </div>
                        )}
                        {isConsumable && (
                            <button
                                disabled={!unusedConsumableTargetExists}
                                title={!unusedConsumableTargetExists
                                    ? 'All supported effect targets are already configured.'
                                    : undefined}
                                type="button"
                                onClick={this.addConsumableEffect}
                            >
                                Add effect
                            </button>
                        )}
                        {!unusedConsumableTargetExists && (
                            <small>All supported effect targets are already configured.</small>
                        )}
                        {consumableEffects.length > 0 && (
                            <div className="admin-consumable-preview" aria-label="Consumable effect preview">
                                <strong>Preview</strong>
                                {instantConsumableEffects.length > 0 && (
                                    <ul>
                                        {instantConsumableEffects.map((effect, index) => (
                                            <li key={`instant-${index}`}>
                                                {formatConsumableEffect(effect, consumableTargets)}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {timedConsumableEffects.length > 0 && (
                                    <>
                                        <span>
                                            For {formatConsumableDuration(durationSeconds) || 'a valid duration'}:
                                        </span>
                                        <ul>
                                            {timedConsumableEffects.map((effect, index) => (
                                                <li key={`timed-${index}`}>
                                                    {formatConsumableEffect(effect, consumableTargets)}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        )}
                    </fieldset>
                )}





                <label className='labelBackground1'>Stats/Procs:
                    {stats.map((obj, index) => {
                        // const foundStat = item.stats?.statEntries.find(x => x.name === obj.name);
                        const foundStats = item.stats?.statEntries.filter(x => x.statId === obj.id);
                        return foundStats?.map((foundStat) => {
                            return (
                                <label>{obj.name}:
                                    {(obj.statType === 0) ? //Stat
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From:</label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={obj.id + "_$$_valueFrom"} value={foundStat.valueFrom} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={obj.id + "_$$_valueTo"} value={foundStat.valueTo} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat(obj.id)}>delete</button></div>
                                        </div>
                                        : // Proc
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={obj.id + "_$$_valueFrom"} value={foundStat.valueFrom} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={obj.id + "_$$_valueTo"} value={foundStat.valueTo} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>ProcPercent:</label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={obj.id + "_$$_procPercent"} value={foundStat.procPercent} onChange={(e) => this.handleStatsChange(e, obj)} />%</div></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat(obj.id)}>delete</button></div>

                                        </div>


                                    }

                                </label>);
                        });
                    })}


                    <div><label>Add another stat/proc:</label>
                        <select
                            name="type"
                            value={0}
                            onChange={this.addAnotherStat}
                        >
                            <option key={-1} value="default">Add Stat</option>
                            {stats.map((obj, index) =>
                                <option key={index} value={obj.id}>{obj.name}</option>
                            )}

                        </select>
                    </div>


                </label>
                <fieldset className='labelBackground1'>
                    <legend>Crafting materials</legend>
                    <div className='row'>
                        {item.craftingMats?.map((obj, index) => {
                            const item = loadedItems[obj.itemId];
                            if (!item) this.handleImageLoad(obj.itemId);
                            return (
                                <div key={obj.itemId} className='gridItem'>
                                    <div className='image-wrapper'>
                                        <a
                                            aria-label={`Open ${item?.name || obj.itemId} in Item editor`}
                                            className="admin-crafting-material__link"
                                            href={`/admin/Items?itemId=${encodeURIComponent(obj.itemId)}`}
                                        >
                                            <ImageLoader
                                                className="adminCraftingImage"
                                                imageId={item?.imageId}
                                                animatedMediaId={item?.animatedMediaId || item?.animatedImageId}
                                                variant={MEDIA_VARIANTS.MODAL}
                                                alt=""
                                            />
                                            <span>{item?.name || obj.itemId}</span>
                                        </a>
                                        {/* {loadedImages[item?.imageId] ? (
                                            <img
                                                className='craftingImage'
                                                src={loadedImages[item?.imageId]}
                                                alt={item?.name}
                                                loading="lazy"
                                            />
                                        ) : (
                                            <img
                                                className='img-placeholder craftingImage'
                                                alt="placeholder"

                                                loading="lazy"
                                            />
                                        )} */}
                                        <button className='floatingDelTopRight' value={obj.itemId} onMouseUp={this.removeCraftingItem}>X</button>
                                    </div>
                                    <label>Amount:
                                        <input type="number" name="amount" value={obj?.amount} onChange={(event) => this.handleInputChangeCraftingMats(event, item, index)} />
                                    </label>

                                </div>
                            );

                        })}
                    </div>
                    <div><span>Add crafting material:</span>
                        <button id="Craft" onClick={this.showItemPopup} type="button">Add</button>
                    </div>
                    <small>
                        Equipment recipes require exactly one catalyst matching their minimum crafted rarity.
                    </small>
                </fieldset>
                {!creatingNewItem && (
                    <fieldset className='labelBackground1'>
                        <legend>Used as crafting material in</legend>
                        {materialUses.length > 0 ? (
                            <ul className="admin-crafting-usage-list">
                                {materialUses.map(use => (
                                    <li key={use.id}>
                                        <a
                                            href={`/admin/Items?itemId=${encodeURIComponent(use.id)}`}
                                        >
                                            {use.name || use.id}
                                        </a>
                                        <span aria-label={`Quantity ${use.amount}`}>
                                            × {use.amount}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <small>This item is not used by any crafting recipe.</small>
                        )}
                    </fieldset>
                )}
                <fieldset className="admin-progression-fieldset">
                    <legend>Loot Sources</legend>
                    <label>Drops from enemies:
                        <input
                            type="checkbox"
                            name="dropsFromEnemies"
                            checked={item.dropsFromEnemies !== false}
                            onChange={this.handleInputChange}
                            aria-describedby="item-enemy-loot-help"
                        />
                    </label>
                    <small id="item-enemy-loot-help">
                        Turn this off for salvage-, crafting-, or container-only items. Region and Enemy only filter enabled enemy drops; loot-container entries are configured separately and can be combined.
                    </small>
                    <label>Region:
                        <select
                            name="regionId"
                            value={item.regionId || ''}
                            onChange={this.handleInputChange}
                            disabled={item.dropsFromEnemies === false}
                            aria-describedby="item-enemy-loot-help"
                        >
                            <option value="">Any Region</option>
                            {regions.map(region => (
                                <option key={region.id} value={region.id}>{region.name}</option>
                            ))}
                        </select>
                    </label>
                    <label>Enemy:
                        <select
                            name="enemyId"
                            value={item.enemyId || ''}
                            onChange={this.handleInputChange}
                            disabled={item.dropsFromEnemies === false}
                            aria-describedby="item-enemy-loot-help"
                        >
                            <option value="">Any Enemy</option>
                            {enemies.map(enemy => (
                                <option key={enemy.id} value={enemy.id}>{enemy.name}</option>
                            ))}
                        </select>
                    </label>
                </fieldset>


                {
                    creatingNewItem ?
                        <div>
                            {/* Form to create a new item, similar to the update form... */}
                            <button className="button-primary" onClick={() => this.submitItem(onCreate)}>Create</button>
                            <button className="button-secondary" onClick={() => onCancelCreate()}>Cancel</button>
                        </div>
                        :
                        <div>
                            <button className="button-primary" onClick={() => this.submitItem(onUpdate)}>Update</button>
                            <button className="button-critical" onClick={() => onDelete(item)}>Delete</button>

                        </div>
                }
                {/* <button onClick={this.handleUpload}>upload</button> */}
            </div >
        );


    }

}
